// @flow
import { RESORT_WELLNESS } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { buildProductArgs } from 'Utils/graphql';
import { LINE_PRODUCT_WELLNESS } from 'Utils/request/requestDictionary';

type CMSProps = {
  resortId: string,
  title: string,
  onDemand: string,
  included: string,
  spaEquipmentTitle: string,
  age: string,
  adultsOnly: string,
  allAges: string,
  close: string,
};

type GQLProps = {
  spa: Array<Category>,
  spaDetail: Array<Category>,
  config: CMSContent,
};

type LineProps = CMSProps & GQLProps;

export const productWellnessLegacyResolver = {
  name: RESORT_WELLNESS,
  props() {
    return {
      displayed: (props: LineProps): boolean => Boolean(props?.spa[0]?.activities[0]),
    };
  },
  resolve(
    appContext: AppContext,
    props: CMSProps,
    pageContext: PageContext,
    location: ProductRouterLocation,
  ): Promise<GQLProps> {
    const { resortId: productId } = props;
    const { urlParams } = location;
    const categoriesForSpaArgs = buildProductArgs(productId, urlParams, { categoryId: 'SPA' });
    const categoriesForSpaDetailArgs = buildProductArgs(productId, urlParams, {
      tags: 'SPA_DETAIL',
    });

    const query = `query {
      spa: categories(${categoriesForSpaArgs}){
        activities {
          description
          equipments { name description }
          logo
          footnotes
          ageInMonths { min }
        }
      }
      spaDetail: categories(${categoriesForSpaDetailArgs}){
        id
        name
        activities { id name image included description duration adultsOnly ageInMonths { min } }
      }
      config {
        common {
          participants {
            year {
              _0
              _1
              n
            }
          }
        }
      }
    }`;

    return graphQLClient.runQuery(query, appContext, { requestName: LINE_PRODUCT_WELLNESS });
  },
};
